/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// NewUser page components
import FormField from "views/users/account/components/BasicInfo/FormField";

import { getUserData } from "Utils/helpers";

function UserInfo({ formData, informParent }) {
  const { formField, values, errors, touched } = formData;
  const { firstName, lastName, username, email } = formField;
  const { firstName: firstNameV, lastName: lastNameV, username: usernameV, email: emailV } = values;

  const [platformsOptions, setPlatformsOptions] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([]);

  const userData = getUserData();

  async function initData() {}

  useEffect(() => {
    if (formData) initData();
  }, [formData]);

  useEffect(() => {
    if (Object.keys(touched).length > 0) informParent(true);
  }, [touched]);

  return (
    <SoftBox>
      <SoftBox>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={7}>
            <Grid item xs={12} sm={12}>
              <FormField
                type={firstName.type}
                label={firstName.label}
                name={firstName.name}
                value={firstNameV}
                placeholder={firstName.placeholder}
                error={errors.firstName && touched.firstName}
                success={firstNameV.length > 0 && !errors.firstName}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormField
                type={lastName.type}
                label={lastName.label}
                name={lastName.name}
                value={lastNameV}
                placeholder={lastName.placeholder}
                error={errors.lastName && touched.lastName}
                success={lastNameV.length > 0 && !errors.lastName}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormField
                type={username.type}
                label={username.label}
                name={username.name}
                value={usernameV}
                placeholder={username.placeholder}
                error={errors.username && touched.username}
                success={usernameV.length > 0 && !errors.username}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormField
                type={email.type}
                label={email.label}
                name={email.name}
                value={emailV}
                placeholder={email.placeholder}
                error={errors.email && touched.email}
                success={emailV.length > 0 && !errors.email}
              />
            </Grid>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for UserInfo
UserInfo.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  informParent: PropTypes.func,
};

export default UserInfo;
